export default __webpack_public_path__ + "static/media/ComputoriaImageOne.dc2e4895.png";